import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@mui/material'
import { MButton, TextInput } from 'components'
import type React from 'react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { APIs } from 'services/apis'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'
import * as yup from 'yup'
import { type ErrorMessageType, type PremiseType } from './ServiceForm'

const schema = yup
    .object({
        streetNumber: yup.string().required('Street number is a required field'),
        streetName: yup.string().required('Street name is a required field'),
        zipCode: yup.string().required('Zip code is a required field')
    })
    .required()

interface SearchAddressFormProps {
    handleNext: () => void
    handleBack: () => void
    setErrorMessage: (errorMessage: ErrorMessageType) => void
    setPremiseList: (premiseList: PremiseType[]) => void
}

export interface SearchAddressFormType {
    streetNumber: string
    streetName: string
    zipCode: string
}


const SearchAddressForm: React.FC<SearchAddressFormProps> = ({ handleNext, handleBack, setErrorMessage, setPremiseList }: SearchAddressFormProps) => {
    const isMobile = useMobileBreakpoints()
    const [loading, setLoading] = useState<boolean>(false)
    const { handleSubmit, control, formState: { errors } } = useForm<SearchAddressFormType>({
        mode: 'all',
        defaultValues: {
            streetNumber: '',
            streetName: '',
            zipCode: ''
        },
        resolver: yupResolver(schema)
    })


    const onSubmit = async (body: SearchAddressFormType): Promise<void> => {
        setLoading(true)
        try {
            const address = `${body.streetNumber} ${body.streetName}`
            const response = await APIs.searchLocation({ addressLine1: address, postal: body.zipCode })
            if ((Boolean(response)) && response.length > 0) {
                setPremiseList(response)
                handleNext()
            } else {
                setErrorMessage({ title: 'No matching addresses found', description: 'Unfortunately, we couldn\'t find a address that matches the provided information. Please try entering your information again or contact us.' })
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box>
            <TextInput fieldLabel='Street number' fieldName='streetNumber' fieldType='text' placeholder='Enter your street number' control={control} errors={errors} />
            <TextInput fieldLabel='Street name' fieldName='streetName' fieldType='text' placeholder='Enter your street name' control={control} errors={errors} />
            <TextInput fieldLabel='Zip code' fieldName='zipCode' fieldType='text' placeholder='Enter your zip code' control={control} errors={errors} />
            <Box display="flex" my={3} width={isMobile ? '100%' : '50%'} flexDirection={isMobile ? 'column' : 'row'} gap={2}>
                <MButton fullWidth variant='outlined' texttransform='none' rounded='true' onClick={() => { handleBack() }}>
                    Back
                </MButton>
                <MButton fullWidth variant='contained' type='submit' texttransform='none' rounded='true' disabled={loading} onClick={handleSubmit(onSubmit)} loading={loading}>
                    Validate Address
                </MButton>
            </Box>

        </Box>
    )
}

export default SearchAddressForm
